import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import CollapsibleMultiselect from './CollapsibleMultiselect';
import ReportComponent from '../../utils/ReportComponent/ReportComponent';
import typeOf from '../../helpers/typeOf';

const Default = ({ segment, values, onAction, t }) => {
    const getList = useCallback((segmentKey) => {
        const metricParams = ReportComponent.getParams({key: segmentKey, metricKey: 'GroupBy'});
        return metricParams.values;
    }, []);

    const [state, setState] = useState({
        segment: segment,
        values: values,
        list: getList(segment)
    });

    const parseData = useCallback((currentValues, currentList) => {
        let parsedValues = [];

        if (currentValues.length && !typeOf.isObject(currentValues[0])) {
            parsedValues = currentList.filter((item) => currentValues.indexOf(item.value) !== -1);
        }

        return parsedValues;
    }, []);

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            values: parseData(prevState.values, prevState.list)
        }));
    }, []);

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            segment: segment,
            values: values.length ? prevState.values : values,
            list: getList(segment)
        }));
    }, [segment, values, getList]);

    const onChange = useCallback((value) => {
        setState(prevState => ({
            ...prevState,
            values: value
        }));
    }, []);

    useEffect(() => {
        if (state.values !== values) {
            onAction(state.values);
        }
    }, [state.values, onAction, values]);

    const messages = t?.multiselect || {};
    const staticNames = t?.reportPage || {};

    return (
        <CollapsibleMultiselect
            placeholder={staticNames.enterValue}
            value={state.values}
            dataKey="value"
            textField="title"
            data={state.list}
            onChange={onChange}
            messages={messages}
        />
    );
};

Default.propTypes = {
    segment: PropTypes.string,
    values: PropTypes.array,
    onAction: PropTypes.func,
    t: PropTypes.object
};

Default.propTypes = {
    segment: PropTypes.string,
    values: PropTypes.array,
    onAction: PropTypes.func,
    t: PropTypes.object
};

Default.defaultProps = {
    segment: '',
    values: [],
    onAction: () => {},
    t: {}
};

export default withTranslation(Default);